import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import _ from 'lodash';

import {
  fetchProject,
  setProject,
  deleteProject,
  setProjectForm,
} from '../../../store/modules/project';
import { deleteFile } from '../../../store/modules/file';

import Project from '../components/Project';

const mapActionCreators = {
  fetchProject,
  setProject,
  deleteProject,
  setProjectForm,
  deleteFile,
  push,
};

const mapStateToProps = state => ({
  currentProjectId: state.project.current,
  project: state.project.projects[state.project.current],
  formOpen: state.project.formOpen,
  projectCount: Object.keys(
    _.filter(
      state.project.projects,
      o => o.deleted_at === null && o.project_id === null,
    ),
  ).length,
  company: state.project.projects[state.project.current]
    ? state.company.companies[
        state.project.projects[state.project.current].company_id
      ]
    : null,
  projectParent: state.project.projects[state.project.current]
    ? state.project.projects[
        state.project.projects[state.project.current].project_id
      ]
    : null,
  activities: _.filter(
    _.pick(
      state.activity.activities,
      state.project.projects[state.project.current]
        ? state.project.projects[state.project.current].activities
        : null,
    ),
    ['deleted_at', null],
  ),
  projects: _.filter(state.project.projects, {
    deleted_at: null,
    project_id: state.project.current,
  }),
  files: _.filter(
    _.pick(
      state.file.files,
      state.project.projects[state.project.current]
        ? state.project.projects[state.project.current].files
        : null,
    ),
    ['deleted_at', null],
  ),
  tasks: _.filter(
    _.pick(
      state.task.tasks,
      state.project.projects[state.project.current]
        ? state.project.projects[state.project.current].tasks
        : null,
    ),
    ['deleted_at', null],
  ),
  persons: _.filter(
    _.pick(
      state.person.persons,
      state.project.projects[state.project.current]
        ? state.project.projects[state.project.current].persons
        : null,
    ),
    ['deleted_at', null],
  ),
  leader: state.project.projects[state.project.current]
    ? state.staff.staffs[
        state.project.projects[state.project.current].project_leader
      ]
    : null,
  staffs: _.filter(state.staff.staffs, ['deleted_at', null]),
  fetching: state.project.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Project);



// WEBPACK FOOTER //
// ./src/routes/ProjectDetail/containers/ProjectContainer.js